import React from 'react';
// import logoImg from "../../assets/img/logo.png"

function SplashScreen(props) {
    return (
        <div id="fuse-splash-screen">
            <div className="center">
                {/* <div className="logo">
          <img width="125" src={logoImg} alt="logo" />
        </div> */}
                <div className="spinner-wrapper">
                    <div className="spinner">
                        <div className="inner">
                            <div className="gap" />
                            <div className="left">
                                <div className="half-circle" />
                            </div>
                            <div className="right">
                                <div className="half-circle" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(SplashScreen);
